import * as React from 'react';

export function useSelection() {
    const [selectedEntityName, setSelectedEntityName] = React.useState<
        string | null
    >(null);

    const deselectEntity = () => {
        setSelectedEntityName(null);
    };

    return {
        selectedEntityName,
        deselectEntity,
        setSelectedEntityName,
    };
}
